import React from 'react';

const ErrorState = ({ message, onRetry, className = '' }) => {
    return (
        <div className={`flex flex-col items-center justify-center p-8 text-center rounded-2xl bg-[#1B1F27] border border-red-500/20 ${className}`}>
            <div className="w-16 h-16 rounded-full bg-red-500/10 flex items-center justify-center mb-4">
                <span className="material-symbols-rounded text-3xl text-red-500">error</span>
            </div>

            <h3 className="text-xl font-bold text-light mb-2">Something went wrong</h3>

            <p className="text-secondary max-w-sm mb-6">
                {message || "We encountered an unexpected error while trying to load this data. Please try again."}
            </p>

            {onRetry && (
                <button
                    onClick={onRetry}
                    className="flex items-center gap-2 px-6 py-3 rounded-xl bg-slate-800 text-light font-bold hover:bg-slate-700 transition-colors"
                >
                    <span className="material-symbols-rounded text-[20px]">refresh</span>
                    Try Again
                </button>
            )}
        </div>
    );
};

export default ErrorState;
